import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';

import type {
  FooterPopupImageLinkBlock,
  LinkStrapiBlock,
} from './FooterPopupImageLink';

export function isLinkBlock(
  block: FooterPopupImageLinkBlock
): block is LinkStrapiBlock {
  return !!block.link;
}

/**
 * Override for cookie policy link, to please Google without creating too much complexity in Strapi.
 *
 * Follows similar (albeit not great) approach as to how we get the 3rd party signup event for
 * the Google button in our Hero slices (src/features/HomepageHero/helpers.ts)
 *
 */
export function isCookiePolicyLink(link: LinkButtonStrapiProps): boolean {
  return link.url.includes('cookie-policy');
}
